import { render, staticRenderFns } from "./out-collection-import-list.vue?vue&type=template&id=ea47a466&scoped=true"
import script from "./out-collection-import-list.vue?vue&type=script&lang=ts"
export * from "./out-collection-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea47a466",
  null
  
)

export default component.exports